<template>

    <div>
        <DeliveryAddressRedirect
            v-if="entity.id"
            :entity-type="BUSINESS_TYPE.GROCER"
            :entity-id="+entity.id"
        >
            <template v-slot:tabs>
                <GrocerTabLinks />
            </template>
        </DeliveryAddressRedirect>
    </div>

</template>

<script>
    import GrocerTabLinks from '@/components/grocers/GrocerTabLinks';
    import DeliveryAddressRedirect from '@/components/delivery/DeliveryAddressRedirect';
    import { BUSINESS_TYPE } from '@/utils/order';

    export default {

        name: 'EntityDeliveryAddressRedirect',

        components: {
            DeliveryAddressRedirect,
            GrocerTabLinks
        },
  
        data () {
            return {
                BUSINESS_TYPE,
                entity: {}
            }
        },
    
        computed: {},

        async mounted() {
            const id = this.$route.params.id;
            this.entity = (await this.axios.get(`/grocers/${id}`)).data;
        },

        methods: {}
    }
</script>
